<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="400"
    offset-x
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" small text color="primary" class="ma-2">
        <v-icon small>mdi-history</v-icon
        >{{ $t("task.lblStatusChangeHistory") }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar color="primaryLight1" dark height="40px">
        <v-btn icon large>
          <v-icon color="primaryDark">mdi-history</v-icon>
        </v-btn>

        <span>{{ $t("task.lblStatusChangeHistory") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="menu = false" />
      </v-toolbar>
      <v-card-text style="max-height: 300px; overflow-y: auto">
        <v-timeline :dense="$vuetify.breakpoint.smAndDown">
          <v-timeline-item
            v-for="(item, index) in statusHistory"
            :key="`${item.email}-${index}`"
            small
          >
            <v-card class="elevation-4" max-width="500">
              <v-card-text class="pa-0">
                <v-list-item dense>
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-icon size="18" class="mb-1 mr-1"
                        >mdi-road-variant</v-icon
                      ><strong>{{
                        getStatusLabel(item.status)
                      }}</strong></v-list-item-title
                    >
                    <v-list-item-title
                      ><v-icon size="18" class="mb-1 mr-1">mdi-account</v-icon
                      >{{ item.name }}</v-list-item-title
                    >
                    <v-list-item-title>
                      <v-icon size="18" class="mb-1 mr-1">mdi-calendar</v-icon
                      >{{ getTimeDetails(item.updatedDate) }}
                    </v-list-item-title>
                    <v-tooltip v-if="item.comment" bottom max-width="600px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item-title
                          v-bind="attrs"
                          v-on="on"
                          style="white-space: normal; line-height: 19px"
                        >
                          <v-icon size="18" class="mb-1 mr-1"
                            >mdi-comment</v-icon
                          >{{ ellipsis(item.comment) }}
                        </v-list-item-title>
                      </template>
                      <span style="white-space: wrap !important">
                        {{ item.comment }}</span
                      >
                    </v-tooltip>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import { getTimeDetails } from "@/utils/util";

export default {
  name: "ChangeLogHistory",
  props: {
    statusHistory: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      getStatusLabel: "task/getStatusLabel",
    }),
  },
  data() {
    return {
      menu: false,
      stringLength: 90,
    };
  },
  methods: {
    getTimeDetails,
    ellipsis(string) {
      return this.isEllipsis(string)
        ? string.substring(0, this.stringLength) + "..."
        : string;
    },
    isEllipsis(string) {
      return String(string).length > this.stringLength;
    },
  },
};
</script>

<style>
</style>